import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    //
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    minWidth: "44px",
    height: "44px",
  },

  commentHead: {
    //
    display: "flex",
    fontFamily: "poppins",
    justifyContent: "space-between",
    alignItems: "center",
    marginRight: "13px",
  },
  time: {
    //
    color: theme.palette.text.tertiary,
    fontFamily: "poppins",
    fontSize: "14px",
  },

  annotationText: {
    //
    cursor: "pointer",
    color: "#008cdb",
    marginRight: "8px",
  },
  image: {
    //
    marginLeft: "40px",
    borderRadius: "10px",
    cursor: "pointer",
  },

  userName: {
    //
    margin: "0px 8px",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  commentText: {
    //
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  showHideButton: {
    color: theme.palette.secondary.main,
    paddingLeft: "0px !important",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  notSelectedComment: {
    backgroundColor: theme.palette.primary.main,
    marginTop: "8px",
  },
  commentHead: {
    display: "flex",
    fontFamily: "poppins",
    justifyContent: "space-between",
    alignItems: "center",
    marginRight: "13px",
  },
  repliesHead: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  colorText: {
    color: theme.palette.secondary.main,
  },
  commentText: {
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  time: {
    color: theme.palette.text.tertiary,
    fontFamily: "poppins",
    fontSize: "14px",
  },
  replyDescription: {
    margin: "8px 0px 4px 66px",
    paddingRight: "4px",
  },
}));

export default useStyles;
